import React from "react";
import ReactGA from "react-ga";
import "./Main.scss";

import { Container } from "reactstrap";

import SimpleNavbar from "components/Navbars/SimpleNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import SimpleGallery from "components/Gallery/SimpleGallery.js";
import Values from "components/MainPage/Breaker/Values.js";
import Services from "components/MainPage/Services/Services.js";
import ContactForm from "components/MainPage/ContactForm/ContactForm.js";
import Intro from "components/MainPage/Intro/Intro.js";
import Industries from "components/MainPage/Breaker/Industries";
import Clients from "components/MainPage/Breaker/Clients";
import ExitIntentPopup from "components/Popups/ExitIntentPopup.js";
import CookieConsent from "components/CookieConsent/CookieConsent.js";

class Landing extends React.Component {
  state = {
    contact_result_message: "",
    contact_result_color: "red",
    contact_email_valid: false,
    contact_form_valid: false,
    contact_email_style: "",
    email_name: "",
    email_address: "",
    email_message: "",
    phone_number: "",
    portfolio_in_view: 1,
    contact_in_view: 0,
  };

  isMobile = window.innerWidth <= 1280;

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (!this.isMobile) {
      window.addEventListener("scroll", this.handleScrollChange);
    } else {
      this.setState({ portfolio_in_view: 1, contact_in_view: 1 });
    }
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScrollChange);
  }

  // TODO : might be better way to set animations for sections
  // Associates animations to the user's location on the page.
  handleScrollChange = (event) => {
    if (
      window.scrollY >= document.body.clientHeight / 2.25 &&
      this.state.portfolio_in_view === 0
    ) {
      this.setState({ portfolio_in_view: 1 });
    }
  };

  render() {
    return (
      <>
        {ReactGA.initialize(process.env.REACT_APP_GA_ID, {
          gaOptions: { siteSpeedSampleRate: 100 },
        })}
        <SimpleNavbar />
        <main ref="main">
          <section className="landing-start section section-md bg-bright">
            <Container>
              <div className="header">
                {this.isMobile && (
                  <img
                    src={require("../../assets/img/logo/rv-logo-wht.png")}
                    alt="logo"
                    className="img-header"
                  />
                )}
                <h1>
                  PREMIUM SPRAY FOAM INSULATION<br></br>
                  <span class="gta">GREATER TORONTO AREA</span>
                </h1>
              {!this.isMobile && (
                <img
                  src={require("../../assets/img/logo/rv-logo-wht.png")}
                  alt="logo"
                  className="img-header"
                />
              )}              
              </div>
            </Container>
          </section>
          {/* ---------------------------------------- INDUSTRIES ---------------------------------------- */}
          <section className="industries-section section section-sm bg-default">
            <Industries />
          </section>
          {/* ---------------------------------------- SERVICES ---------------------------------------- */}
          <section id="services" className="section bg-brighter section-padding">
            <Container className="services-section">
              <h2 className="services-title">SERVICES</h2>
              <Services />
            </Container>
          </section>
          <section className="values-section section section-sm bg-primary">
            <Values />
          </section>

          <section id="about-us" className="intro-section section section-lg bg-default">
            <Intro />
          </section>
          {/* ---------------------------------------- PROJECTS ---------------------------------------- */}
          <section id="projects" className="section bg-brighter section-padding">
            <Container
              className="portfolio"
            >
              <h2 className="text-primary text-center projects-title">
                PROJECTS
              </h2>
              <div className="gallery">
                <SimpleGallery />
              </div>
            </Container>
          </section>
          {/* ---------------------------------------- CLIENTS ---------------------------------------- */}
          <section className="clients-section section section-sm bg-default">
            <Clients />
          </section>
          {/* ---------------------------------------- CONTACT US ---------------------------------------- */}
          <section
            id="contact"
            className="section section-lg section-contact-us pt-200 bg-brighter section-padding"
          >
            <Container className="">
              <ContactForm />
            </Container>
          </section>
        </main>
        <SimpleFooter />
        <ExitIntentPopup />
        <CookieConsent />
      </>
    );
  }
}

export default Landing;
